import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface TwoDIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const TwoDIcon = ({ className, ...props }: TwoDIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4004 3.25C22.1457 3.25021 22.7498 3.85434 22.75 4.59961V16.252C22.7499 16.6098 22.6076 16.953 22.3545 17.2061L19.2061 20.3545C18.953 20.6076 18.6098 20.7499 18.252 20.75H2.59961C1.85434 20.7498 1.25021 20.1457 1.25 19.4004V4.59961C1.25021 3.85433 1.85434 3.25021 2.59961 3.25H21.4004ZM2.75 19.25H17.25V16.5996C17.2502 15.8543 17.8543 15.2502 18.5996 15.25H21.25V4.75H2.75V19.25ZM18.75 16.75V18.6895L20.6895 16.75H18.75Z"
      fill="currentColor"
    />
  </svg>
);

export default TwoDIcon;
